export default "__VITE_ASSET__8923cc34__"